import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfirmationService, MessageService } from 'primeng/api';

import { ComissaoService } from '../comissao.service';
import { Comissao, GrupoComissao, TipoComissao } from '../models/comissao';

@Component({
  selector: 'app-comissao',
  templateUrl: './comissao.component.html',
  styleUrls: ['./comissao.component.scss']
})
export class ComissaoComponent implements OnInit {

  constructor(private comissaoService: ComissaoService,
              private router: Router,
              private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

  public listaComissao: Comissao[] = [];
  public listaGrupo: GrupoComissao[] = [];
  public listaTipo: TipoComissao[] = [];
  public comissao: Comissao;
  public selectedGrupo: GrupoComissao;
  public selectedTipo: TipoComissao;
  

  //TODO - Definir regra de Insert / Delete + Edição Grupo / Produto
  public flagEdit: boolean = false;
  public flagDelete: boolean = false;
  public flagDisabledGrupo: boolean =true;
  public flagDisabledProduto: boolean = true;

  public displayMsg: boolean = false;
  public displayDialog: boolean;
  public submitted: boolean;

  ngOnInit(): void {
    this.selectedGrupo = { idGrupoComissao: 0, nome: '', cdGrupoComissao: '', }
    this.selectedTipo = { idComissaoTipo: 0, nome: '', cdComissaoTipo: '', }
    this.getComissoes();
    this.getGrupos();
    this.getTipos();
  }


  getComissoes() {
    this.comissaoService.getComissoes().subscribe(
      (res) => {
        if (res) {
          this.listaComissao = res;
        }
      },
      err => {
        console.log("ComissaoList - Comissoes");
        console.log(err);
      }
    );
  }

  getGrupos() {
    this.comissaoService.getGruposComissao().subscribe(
      (res) => {
        if (res) {
          this.listaGrupo = res;
        }
      },
      err => {
        console.log("ERRO DESCONTO - GRUPO ");
        console.log(err);
      }
    );
  }

  getTipos() {
    this.comissaoService.getTiposComissao().subscribe(
      (res) => {
        if (res) {
          this.listaTipo = res;
        }
      },
      err => {
        console.log("ERRO DESCONTO - GRUPO ");
        console.log(err);
      }
    );
  }


  getSelectedGrupo(idGrupoComissao: number) {
    return this.listaGrupo.find(x => x.idGrupoComissao === idGrupoComissao);
  }

  SetGrupo() {
    this.comissao.idGrupoComissao = this.selectedGrupo.idGrupoComissao;
  }

  getSelectedTipo(idComissaoTipo: number) {
    return this.listaTipo.find(x => x.idComissaoTipo === idComissaoTipo);
  }

  SetTipo() {
    this.comissao.idComissaoTipo = this.selectedTipo.idComissaoTipo
  }

  

  openNew() {
    this.submitted = false;
    this.displayDialog = true;
    this.comissao = {};
  }

  edit(comissao: Comissao) {
    this.selectedTipo = this.getSelectedTipo(comissao.idComissaoTipo);
    this.selectedGrupo = this.getSelectedGrupo(comissao.idGrupoComissao);
    this.comissao = { ...comissao };
    this.displayDialog = true;
  }  


  hideDialog() {
    this.displayDialog = false;
    this.submitted = false;
  }
  
  save() {
    this.submitted = true;

    if (this.comissao.idComissaoRegra) {

      this.comissaoService
        .updComissao(this.comissao)
        .subscribe(
          //() => this.updProdutoGrupoDesconto(),
          () => this.getComissoes(),
          err => {
            console.log("ERRO DESCONTO - SAVE-UPD")
            console.log(err)
          }
        );
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Comissão atualizada com sucesso!', life: 3000 });
    } else {
      this.comissaoService
        .addComissao(this.comissao)
        .subscribe(
          //() => this.updProdutoGrupoDesconto(),
          () => this.getComissoes(),
          err => {
            console.log("ERRO DESCONTO - SAVE-ADD")
            console.log(err)
          }
        );

      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fluxo cadastrado com sucesso!', life: 3000 });
    }

    this.listaComissao = [...this.listaComissao];
    this.displayDialog = false;
    this.comissao = {};
  }

}

